import validate from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@types+node@26.1.0_@vue+compiler-sfc@3.5.39_cac@6.7.1_8e0ba05ecab5bfe67dcade06ccd539f0/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45flypay_45return_45global from "/nuxtWeb/middleware/00.flypayReturn.global.ts";
import auth_45global from "/nuxtWeb/middleware/auth.global.ts";
import domain_45redirect_45global from "/nuxtWeb/middleware/domainRedirect.global.ts";
import manifest_45route_45rule from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@types+node@26.1.0_@vue+compiler-sfc@3.5.39_cac@6.7.1_8e0ba05ecab5bfe67dcade06ccd539f0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _00_45flypay_45return_45global,
  auth_45global,
  domain_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/nuxtWeb/middleware/auth.ts")
}